import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { IconButton } from '@material-ui/core';
import questionCircle from '../../../../shared/assets/questionCircle.svg';

const FreshDeskStyle = makeStyles({
  iconDimensions: {
    height: 30,
    width: 30,
    '&&:hover': {
      filter: 'brightness(0.8)',
    },
  },
  buttonSettings: {
    margin: '0',
    padding: '8px 8px 8px 8px',
    '&&:hover': {
      backgroundColor: 'transparent',
    },
    '&&:active': {
      backgroundColor: 'transparent',
    },
  },
});

/* Este componente corresponde al icono de ayuda que abre el formulario de freshdesk,
permitiendole al usuario abrir el formulario. */

const FreshDeskIcon = () => {
  const classes = FreshDeskStyle();

  const openFreshDesk = () => {
    if (typeof window['FreshworksWidget'] === 'function') {
      window['FreshworksWidget']('open');
    }
  };

  return (
    <IconButton
      disableRipple={true}
      disableTouchRipple={true}
      onClick={openFreshDesk}
      className={`${classes.buttonSettings} helpStep`}
    >
      <img src={questionCircle} className={classes.iconDimensions} />
    </IconButton>
  );
};

export default FreshDeskIcon;
